import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import { Button } from '../../../../../../../components';
import { selectMediaExport } from '../../../../../../../store/modules/articles/selectors';
import { notify } from '../../../../../../../store/modules/notifications/actions';
import useStyles from '../styles';

const CopyVideoPreviewAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { media } = useSelector(selectMediaExport);

  const clickHandler = useCallback(() => {
    if (media) {
      const url = window.location.href.includes('preview')? window.location.href: `${window.location.href}&preview=${media.id}`;
      if (copyToClipboard(url)) {
        dispatch(
          notify({
            type: 'info',
            icon: 'copy',
            message: 'Video link copied and is ready to paste.',
          }),
        );
      } else {
        dispatch(
          notify({
            type: 'error',
            icon: 'copy',
            message: 'Video link copying failed.',
          }),
        );
      }
    }
  }, [dispatch, media]);

  if (media && media.ref.video) {
    return (
      <Button
        color="default"
        variant="text"
        className={classes.groupAction}
        onClick={clickHandler}
      >
        Copy
      </Button>
    );
  }

  return null;
};

export default CopyVideoPreviewAction;
